import {
  type InfiniteData,
  type QueryKey,
  useInfiniteQuery,
} from "@tanstack/react-query";
import {
  getBankingBatchPayments,
  type EntityListOfBatchPaymentListItemDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const BATCH_PAYMENTS_QUERY_KEY = "BATCH_PAYMENTS";

export const batchPaymentKeys = {
  all: [BATCH_PAYMENTS_QUERY_KEY],
};

type PageParams = {
  offset: number;
  limit: number;
};

type Props = {
  limit?: number;
};

export const useBatchPayments = ({ limit = 20 }: Props = {}) =>
  useInfiniteQuery<
    EntityListOfBatchPaymentListItemDto,
    unknown,
    InfiniteData<EntityListOfBatchPaymentListItemDto>,
    QueryKey,
    PageParams
  >({
    queryKey: batchPaymentKeys.all,
    queryFn: processResponseWithApiProblemDetails(
      ({ pageParam: { limit, offset } }) =>
        getBankingBatchPayments(offset, limit),
    ),
    initialPageParam: { offset: 0, limit },
    getNextPageParam: (lastPage) => {
      if (!lastPage) {
        return undefined;
      }

      const nextOffset = lastPage.offset + lastPage.limit;

      if (nextOffset >= lastPage.totalCount) {
        return undefined;
      }

      return { offset: nextOffset, limit };
    },
  });
